import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const hotCategories = categories.slice(0, 4);
  const quickLinks = [
    { label: t('nav.home'), to: '/' },
    { label: t('nav.category'), to: '/category' },
    { label: t('nav.about'), to: '/about' },
    { label: t('footer.privacy'), to: '/privacy' },
    { label: t('footer.terms'), to: '/terms' },
  ];

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold tracking-wider text-background-50">mm131</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mt-3">
              国内知名高清美女写真图库平台，提供海量精选写真套图、模特图集与时尚摄影资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.categories')}</h4>
            <ul className="space-y-2.5">
              {hotCategories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.links')}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@mm131.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-1314</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>上海市浦东新区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/privacy" className="hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}